import * as React from 'react';
import { useLatestRef } from './useLatestRef';

export function useItemCallback<
  Item,
  CB extends
    | (
      (item: Item, ...any: any[]) => any
    )
    | undefined,
>(
  item: Item,
  cb: CB,
): CB extends ((...any: any) => any) ? ((...params: Parameters<any>) => ReturnType<CB>) : undefined {
  const cbRef = useLatestRef(cb);
  const itemRef = useLatestRef(item);

  const callback = React.useCallback((...params: any) => {
    return cbRef.current?.(itemRef.current, ...params);
  }, [cbRef, itemRef]);

  return (
    cb == null
      ? null
      : callback
  ) as any;
}
